import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import ProjectDeviceTypePageContent from '@shared/components/organization/projects/deviceType/ProjectDeviceTypePageContent';
import useCurrentOrgProjectsFetching from '@shared/hooks/useCurrentOrgProjectsFetching';
import { useTranslation } from 'react-i18next';

export default function ProjectDeviceTypeDetailPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { currentOrgDeviceType } = useCurrentOrgProjectsFetching();

    return (
        <>
            <PageHeader
                title={currentOrgDeviceType?.name ?? t('common:organization.projects.deviceType.title')}
                description={
                    currentOrgDeviceType?.id
                        ? `${t('common:organization.projects.deviceType.id')}:  ${currentOrgDeviceType.id}`
                        : t('common:organization.projects.deviceType.description')
                }
                items={items}
            />
            <ProjectDeviceTypePageContent />
        </>
    );
}
